<template>
  <div class="group-456">
    <div class="rectangle-200"></div>
    <div class="text roboto-medium-azure-radiance-24px">Начать обучение</div>
  </div>
</template>

<script>
export default {
  name: "Group456",
};
</script>

<style>
.group-456 {
  height: 46px;
  left: 306px;
  position: absolute;
  top: 328px;
  width: 268px;
}

.rectangle-200 {
  background-color: var(--white);
  border: 1.5px solid;
  border-color: var(--aqua-pearl);
  border-radius: 14px;
  height: 46px;
  left: 0;
  position: absolute;
  top: 0;
  width: 266px;
}

.text {
  left: calc(50% - 102px);
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: calc(50% - 16px);
  white-space: nowrap;
  width: 201px;
}
</style>
